import xhr from 'Common/utils/xhr'
import { folderItemsEndpoint } from './endpoints'

/**
 * Put an item into one or more folders
 * @param {Object} config
 * @param {number} config.fileableId - The fileable ID of the folder item
 * @param {string} config.fileableType - The fileable type of the folder item
 * @param {number[]} config.inFolders - The list of folder IDs to place the folder item in
 */
const putItem = ({ fileableId, fileableType, inFolders }) =>
  xhr({
    url: `${folderItemsEndpoint}/move`,
    method: 'PUT',
    data: {
      folders: inFolders,
      folder_item: {
        fileable_id: fileableId,
        fileable_type: fileableType,
      },
    },
  })

export default putItem
